<template>
  <v-container fluid>
    <v-row>
      <!-- FILEMANAGER -->
      <v-col>
        <media-manager />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import mediaManager from "./MediacenterPage/MediaManager";

export default {
  components: {
    mediaManager,
  },
  created() {
    document.title = this.$t("navbar.mediacenter") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.mediacenter"));
  },
};
</script>

<style></style>
